import React from 'react'
import  UserProfile from "../Integration/UserProfile"
import Header from '../Integration/Header'

function PageUserprofile() {
  return (

    <div>
        <Header/>
        <UserProfile/>
        
        </div>
  )
}

export default PageUserprofile